<template>
  <div class="settings-tab">
    <div class="row mt-4">
      <div class="col-10 offset-1">
        <h4 class="mb-3">Settings</h4>
      </div>

      <div class="col-10 offset-1">
        <TextSetting :text="'On slayer task'" :icon="'/static/images/icons/slayer.png'" :setting="settings.onTask"
                     @update="$emit('update', 'onTask')"></TextSetting>
      </div>
      <div class="col-10 offset-1 mt-2">
        <TextSetting :text="'In Wilderness'" :icon="'/static/images/icons/wilderness_skull.png'"
                     :setting="settings.inWilderness"
                     @update="$emit('update', 'inWilderness')"></TextSetting>
      </div>
      <div class="col-10 offset-1 mt-2">
        <TextSetting :text="'Kandarin Hard Diary'" :icon="'/static/images/icons/achievement_dairy.png'"
                     :setting="settings.kandarinDiary"
                     @update="$emit('update', 'kandarinDiary')"></TextSetting>
      </div>
    </div>

  </div>
</template>

<script>
  import Setting from "./settings/Setting";
  import TextSetting from "./settings/TextSetting";

  export default {
    name: "SettingsTab",
    components: {TextSetting, Setting},
    props: {
      settings: {
        type: Object,
      }
    }
  }
</script>

<style scoped>
  p.rs-text {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/SettingsTab.vue